// extracted by mini-css-extract-plugin
export default {"leftsideBar":"style_leftsideBar__0n-nE","appiconCnt":"style_appiconCnt__wdJnA","appicon":"style_appicon__Y0hNI","active":"style_active__geRra","fadeIn":"style_fadeIn__1aHLf"};